<template>
    <div class="cluster-card-wrapper">
        <div class="text-keyword">
            <strong>{{ keywordLabel }}</strong>
            <div class="single-text">
                <span v-for="(item, index) in keywords" :key="index">{{ item }}</span>
            </div>
        </div>
        <ClusterQuestionList :data="clusterCardQuestion" @checkChange="itemCheckChange" />
        <ClusterOptions :allCheck="allCheckFlag" :config="cardConfig" @checkAllChange="checkAllChange" @btnClick="btnClickHandle"> </ClusterOptions>
    </div>
</template>

<script>
import ClusterQuestionList from "./ClusterQuestionList";
import ClusterOptions from "./ClusterOptions";
import QuestionEditModal from "@/views/zhiji/components/questionEdit/QuestionEditModal";

import { cardBottons } from "../../clusterPageConfig.js";
import { errorCode } from "@/views/zhiji/js/common/constants.js";
import i18n from "@/i18n";

export default {
    name: "ClusterCard",
    props: ["cardData"],
    components: {
        ClusterQuestionList,
        ClusterOptions
    },
    data() {
        return {
            keywords: this.cardData.clusterKeywords,
            checkedRows: []
        };
    },
    computed: {
        clusterCardQuestion() {
            return this.convertListData(this.cardData.questionList);
        },
        allCheckFlag() {
            return this.checkedRows.length !== 0 && this.clusterCardQuestion.length == this.checkedRows.length;
        },
        keywordLabel() {
            return this.$t("zhiji.cluster.keyWords");
        },
        cardConfig() {
            return this.getCardConfig();
        }
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.questionCluster[propName];
        },
        checkAllChange(data) {
            data.checked ? this.allPageChecked() : this.removeAllChecked();
        },
        itemCheckChange(data) {
            if (data.checked) {
                this.checkedRows.indexOf(data.questionId) === -1 && this.checkedRows.push(data.questionId);
            } else {
                let itemcheckedIdx = this.checkedRows.indexOf(data.questionId);
                itemcheckedIdx !== -1 && this.checkedRows.splice(itemcheckedIdx, 1);
            }
        },
        allPageChecked() {
            this.clusterCardQuestion.forEach(question => {
                this.itemCheckChange({
                    questionId: question.questionId,
                    checked: true
                });
            });
        },
        removeAllChecked() {
            this.checkedRows.splice(0);
        },
        convertListData(question) {
            return question.map(question => {
                return {
                    checked: this.getCheckState(question.questionId),
                    questionId: question.questionId,
                    questionText: question.questionText,
                    isYester: question.isYester,
                    clusterId: question.clusterId
                };
            });
        },
        btnClickHandle(data) {
            const handlers = {
                delete: this.deleteAction,
                linkedQuestion: this.linkedAction,
                createdQuestion: this.createdAction
            };
            if (this.checkedRows.length < 1) {
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "tip",
                        message: i18n.t("zhiji.cluster.selectedTip")
                    }
                });

                return;
            }

            handlers[data].call(this, data);
        },
        deleteAction(itemId) {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: i18n.t("zhiji.cluster.deleteConfim") + " " + this.checkedRows.length + " " + i18n.t("zhiji.cluster.deleteQues"),
                    cancel: () => {},
                    confirm: () => {
                        this.setDeleteRequest(itemId);
                    }
                }
            });
        },
        setDeleteRequest(itemId) {
            let clusterId = "";
            this.clusterCardQuestion.some(question => {
                if (question.checked) {
                    clusterId = question.clusterId;
                    return true;
                }
            });

            this.zhiji
                .requestByServiceName("deleteAllotQuestion", {
                    clusterId: clusterId,
                    questionIds: this.checkedRows,
                    lang: this.getStorePorp("currentLang")
                })
                .then(() => {
                    this.$store.commit("clearCardTotals");
                    this.$emit("itemBtnClick", itemId);
                    this.checkedRows = [];
                });
        },
        linkedAction(itemId) {
            let checkedQuestion = [];
            this.clusterCardQuestion.forEach(function(question) {
                if (question.checked) {
                    checkedQuestion.push(question);
                }
            });
            this.$store.dispatch("zhiji/showModal", {
                type: "LinkedQuestionModal",
                data: {
                    question: checkedQuestion,
                    title: i18n.t("zhiji.cluster.linkQuestion"),
                    confirm: data => {
                        this.saveLinkedQuestion(data, itemId);
                        this.checkedRows.splice(0);
                    }
                }
            });
        },
        saveLinkedQuestion(data, itemId) {
            this.zhiji
                .requestByServiceName("saveLinkedQuestion", {
                    questions: data.questionArray,
                    questionIds: data.questionIdArray,
                    clusterId: data.clusterId,
                    linkQuestionId: data.linkQuestionId,
                    lang: this.getStorePorp("currentLang")
                })
                .then(resp => {
                    if (resp.errCode && resp.errCode !== errorCode.SUCCESS) {
                        this.$store.dispatch("zhiji/showModal", {
                            type: "MessageModal",
                            data: {
                                type: "error",
                                message: resp.errMessage
                            }
                        });
                    }
                    this.$store.commit("clearCardTotals");
                    this.$emit("itemBtnClick", itemId);
                });
        },
        createdAction(itemId) {
            this.saveCreated(itemId);
        },
        saveCreated(itemId) {
            let firstQuestion = "";
            this.clusterCardQuestion.some(function(question) {
                if (question.checked) {
                    firstQuestion = question;
                    return true;
                }
            });
            this.$store.dispatch("zhiji/showModal", {
                type: QuestionEditModal,
                data: {
                    clusterId: firstQuestion.clusterId,
                    clusterQuestionId: firstQuestion.questionId,
                    standQuestion: firstQuestion.questionText,
                    sceneId: "",
                    clusterLang: this.getStorePorp("currentLang"),
                    closeHandler: () => {
                        this.$store.commit("clearCardTotals");
                        this.$emit("itemBtnClick", itemId);
                    }
                }
            });
        },
        getCheckState(uId) {
            return this.checkedRows.some(rowUId => rowUId === uId);
        },
        getCardConfig() {
            return { cardBottons: cardBottons() };
        }
    }
};
</script>

<style lang="scss" scoped>
.cluster-card-wrapper {
    width: calc(33.3% - 16px);
    height: 398px;
    background: #fff;
    margin: 0 16px 16px 0;
    border: 1px solid #d9e4ef;
    border-radius: 4px;
    box-sizing: border-box;
    .text-keyword {
        display: flex;
        align-items: center;
        padding: 11px 0 11px 24px;
        border-bottom: 1px solid #e1eaf2;

        strong {
            font-size: 14px;
            color: #41475e;
        }

        .single-text {
            flex: 1;
            margin-left: 16px;

            span {
                display: inline-block;
                margin: 6px 16px 0 0;
                font-size: 12px;
                padding: 4px 8px;
                background: #f0f3f6;
                border-radius: 16px;
                max-width: 110px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
    }
}
</style>
